import Link from 'next/link';
import type { FC } from 'react';
import { CONDITION_DESKTOP } from 'shared/common/constants';
import styled from 'styled-components';

type QuestionProps = {
  question: string;
  id: string;
};

type QuestionsList = {
  icon: string;
  title: string;
  questions: QuestionProps[];
};

type QuestionsGridProps = {
  list: QuestionsList[];
};

export const QuestionsGrid: FC<QuestionsGridProps> = ({ list }) => (
  <Grid>
    {list.map((item) => (
      <QuestionsGridItem key={item.title}>
        <QuestionIconContainer>
          <QuestionIcon src={`/img/academy/${item.icon}`} alt={item.title} />
        </QuestionIconContainer>
        <QuestionContent>
          <QuestionsTitle>{item.title}</QuestionsTitle>
          <QuestionsList>
            {item.questions.map((question) => (
              <Question key={question.id}>
                <Link href={`#${question.id}`}>
                  <a>
                    <LinkItem>{question.question}</LinkItem>
                  </a>
                </Link>
              </Question>
            ))}
          </QuestionsList>
        </QuestionContent>
      </QuestionsGridItem>
    ))}
  </Grid>
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin: 30px 0 90px 0;
  row-gap: 60px;
  ${CONDITION_DESKTOP} {
    grid-template-columns: 1fr 1fr;
    margin: 90px 0 120px 0;
    row-gap: 90px;
  }
`;

const QuestionsList = styled.div`
  display: flex;
  flex-direction: column;
`;

const QuestionsGridItem = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 20px;
  ${CONDITION_DESKTOP} {
    grid-template-columns: 70px 1fr;
    column-gap: 20px;
  }
`;

const QuestionIconContainer = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: var(--gray5);
  flex-shrink: 0;
  ${CONDITION_DESKTOP} {
    width: 70px;
    height: 70px;
  }
`;

const QuestionIcon = styled.img`
  max-width: 100%;
`;

const QuestionContent = styled.div`
  ${CONDITION_DESKTOP} {
    max-width: 440px;
  }
`;

const QuestionsTitle = styled.div`
  margin-top: 3px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 20px;
`;

const Question = styled.div`
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

const LinkItem = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: #8b33ff;
  font-weight: 500;
`;
